/**
 * @param {number} days Days remaining
 * @param {number} hours Hours remaining
 * @param t
 * @return {string}
 */
const getDaysRemaining = (days, hours, t) => {
    if (days) {
        if (days === 1) {
            return t("{{deadLine}} day remaining", {deadLine: days});
        }

        return t("{{deadLine}} days remaining", {deadLine: days});
    }

    if (!hours || hours === 1) {
        return t("1 hour remaining");
    }

    return t("{{deadLine}} hours remaining", {deadLine: hours});
};

export default getDaysRemaining;
